import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef, useContext } from 'react';
import styled, { css } from 'styled-components';
import { CardContext } from '../context/CardContext';
import { hidden } from '../utils/propTypes/decorators';
const scrollableMixin = css(["flex:1 1 auto;overflow:auto;&:last-child{margin-bottom:", ";}"], ({
  compact
}) => compact ? '24px' : '40px');
const siblingPaddingMixin = css(["+ .private-card__section,+ * .private-card__section{padding-top:0;}"]);
const Section = styled.div.withConfig({
  displayName: "UICardSection__Section",
  componentId: "sc-1dwue9o-0"
})(["padding:", ";border-radius:inherit;", ";"], ({
  compact,
  flush,
  isHeader,
  scrollable
}) => {
  const paddingTop = compact ? '24px' : '40px';
  const paddingBottom = isHeader || scrollable ? '0' : paddingTop;
  const paddingX = flush ? '0' : paddingTop;
  return `${paddingTop} ${paddingX} ${paddingBottom}`;
}, ({
  scrollable
}) => scrollable ? scrollableMixin : siblingPaddingMixin);
const UICardSection = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    className
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className"]);

  const {
    compact
  } = useContext(CardContext);
  return /*#__PURE__*/_jsx(Section, Object.assign({}, rest, {
    ref: ref,
    className: classNames("private-card__section has--vertical-spacing", className),
    compact: compact
  }));
});
UICardSection.defaultProps = {
  flush: false,
  isHeader: false,
  scrollable: false
};
UICardSection.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool,
  isHeader: hidden(PropTypes.bool),
  scrollable: PropTypes.bool
};
UICardSection.displayName = 'UICardSection';
export default UICardSection;